import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { Establishment } from "src/app/services/api";

export const loadOne = createAction("[Establishment] Load One", props<{ slug: string }>());
export const loadOneSuccess = createAction("[Establishment] Load One Success", props<{ establishment: Establishment }>());
export const loadOneFailure = createAction("[Establishment] Load One Failure", props<{ error: HttpErrorResponse }>());
